var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-row',[_c('b-col',[_c('h2',{staticClass:"text-center m-text"},[_vm._v(" Redirecionando para a loja do app "),_c('b',[_vm._v(_vm._s(_vm.formatUrl(_vm.url)))]),_vm._v(" . . .")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }